import {
  DefaultRequestBody,
  RequestParams,
  ResponseResolver,
  rest,
  RestContext,
  RestHandler,
  RestRequest
} from 'msw';
import { PATHS, STATUS } from 'adapters/constants';
import { printChecksHighVolumeData } from 'mocks/mockData/printChecksHighVolumeData';

const responseHandler: ResponseResolver<
  RestRequest<DefaultRequestBody, RequestParams>,
  RestContext,
  any
> = async (_, res, ctx) => {
  const page = _.url.searchParams.get('page');
  const pageSize = _.url.searchParams.get('size');
  const pageValue = page !== null ? parseInt(page, 10) : 0;
  const pageSizeValue = pageSize !== null ? parseInt(pageSize, 10) : 100;
  const data = printChecksHighVolumeData;
  await new Promise(resolve => setTimeout(resolve, 1000));
  return res(
    ctx.status(STATUS.SUCCESS),
    ctx.json({
      ...data,
      vendors: data.vendors.slice(
        (pageValue - 1) * pageSizeValue,
        pageValue * pageSizeValue
      )
    })
  );
};

export const highVolumePrintCheckDataHandler: RestHandler[] = [
  rest.get(PATHS.getHighVolumeVendorsPrintChecksPath('*'), responseHandler)
];
